import { ObjProto as n, nonEnumerableProps as o } from "./_setup.js";
import t from "./isFunction.js";
import r from "./_has.js";
function s(s, u) {
  u = function (n) {
    for (var o = {}, t = n.length, r = 0; r < t; ++r) o[n[r]] = !0;
    return {
      contains: function contains(n) {
        return !0 === o[n];
      },
      push: function push(t) {
        return o[t] = !0, n.push(t);
      }
    };
  }(u);
  var c = o.length,
    i = s.constructor,
    p = t(i) && i.prototype || n,
    e = "constructor";
  for (r(s, e) && !u.contains(e) && u.push(e); c--;) (e = o[c]) in s && s[e] !== p[e] && !u.contains(e) && u.push(e);
}
export { s as default };